import React from "react";
import {
  CheckCircle,
  Settings,
  TestTube,
  Shield,
  Target,
  Bot,
  Sparkles,
} from "lucide-react";
import { Badge } from "./ui/badge";

interface AgentConfigurationSummaryProps {
  agentName: string;
  agentType: string;
  useCase: string;
  industry: string;
  connectionType: string;
  testCount: number;
  complianceRequired: boolean;
}

export const AgentConfigurationSummary: React.FC<
  AgentConfigurationSummaryProps
> = ({
  agentName,
  agentType,
  useCase,
  industry,
  connectionType,
  testCount,
  complianceRequired,
}) => {
  const getAgentTypeIcon = (type: string) => {
    const iconMap: { [key: string]: string } = {
      conversational: "💬",
      sales: "💰",
      content: "✍️",
      analytics: "📊",
      safety: "🛡️",
      development: "💻",
    };
    return iconMap[type] || "🤖";
  };

  const getIndustryIcon = (industry: string) => {
    const iconMap: { [key: string]: string } = {
      ecommerce: "🛒",
      healthcare: "🏥",
      finance: "🏦",
      education: "🎓",
      technology: "💻",
      media: "🎬",
      consulting: "📋",
      manufacturing: "🏭",
      other: "🔧",
    };
    return iconMap[industry] || "🏢";
  };

  return (
    <div className="bg-gray-750 rounded-lg p-6">
      <div className="text-center mb-6">
        <div className="w-16 h-16 bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
          <CheckCircle className="h-8 w-8 text-green-400" />
        </div>
        <h3 className="text-lg font-medium text-gray-100 mb-2">
          Agent Successfully Imported!
        </h3>
        <p className="text-gray-400">
          Your agent "{agentName}" has been successfully imported, we will start
          generating tests for it.
        </p>
      </div>

      <div className="space-y-4">
        <div className="bg-blue-900/20 border border-blue-600/30 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Sparkles className="h-5 w-5 text-blue-400" />
            <h4 className="font-medium text-blue-100">Next: Test Generation</h4>
          </div>
          <p className="text-sm text-blue-200">
            We'll now generate comprehensive tests tailored to your agent's
            type, use case, and industry requirements.
          </p>
        </div>
      </div>
    </div>
  );
};
